import { useState, useEffect } from 'react'
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { Link, useLocation } from '@tanstack/react-router'
import { useIsAuthenticated } from '@azure/msal-react'
import DashboardIcon from '@mui/icons-material/Dashboard'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import PersonIcon from '@mui/icons-material/Person'

const NAV_WIDTH = 240

const navItems = [
  { label: 'Dashboard', to: '/', icon: <DashboardIcon /> },
  { label: 'Mijn coins', to: '/coins', icon: <MonetizationOnIcon /> },
  { label: 'Mijn profiel', to: '/profile', icon: <PersonIcon /> },
]

export function AppNav() {
  const isAuthenticated = useIsAuthenticated()
  const location = useLocation()
  const [mobileValue, setMobileValue] = useState(0)

  useEffect(() => {
    const idx = navItems.findIndex(item => item.to === location.pathname)
    setMobileValue(idx >= 0 ? idx : 0)
  }, [location.pathname])

  if (!isAuthenticated) return null

  return (
    <>
      {/* Desktop sidebar */}
      <Box
        component="nav"
        aria-label="Hoofdnavigatie"
        sx={{ display: { xs: 'none', md: 'block' }, flexShrink: 0, width: NAV_WIDTH }}
      >
        <Drawer
          variant="permanent"
          sx={{
            width: NAV_WIDTH,
            '& .MuiDrawer-paper': {
              width: NAV_WIDTH,
              boxSizing: 'border-box',
              top: '64px',
              height: 'calc(100% - 64px)',
              borderRight: '1px solid',
              borderColor: 'divider',
            },
          }}
        >
          <List>
            {navItems.map((item) => (
              <ListItem key={item.to} disablePadding>
                <ListItemButton
                  component={Link}
                  to={item.to}
                  selected={location.pathname === item.to}
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: 'rgba(0, 83, 161, 0.08)',
                      '& .MuiListItemIcon-root': { color: 'primary.main' },
                      '& .MuiListItemText-primary': {
                        fontWeight: 600,
                        color: 'primary.main',
                      },
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </Box>

      {/* Mobile bottom navigation */}
      <Paper
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
        }}
        elevation={3}
      >
        <BottomNavigation
          value={mobileValue}
          onChange={(_, newValue: number) => setMobileValue(newValue)}
        >
          {navItems.map((item) => (
            <BottomNavigationAction
              key={item.to}
              label={item.label}
              icon={item.icon}
              component={Link}
              to={item.to}
            />
          ))}
        </BottomNavigation>
      </Paper>
    </>
  )
}